const textareafield = {
    color: { value: '{components.fieldcontrol.color.value}' },
    borderColor: { value: '{components.fieldcontrol.borderColor.value}' },
    _focus: {
        borderColor: {
            value: '{components.fieldcontrol._focus.borderColor.value}',
        },
    },
};

export { textareafield };
